import { useState } from 'react';
import { Link } from 'react-router-dom';
import { AlertCircle, ArrowLeft } from 'lucide-react';
import usePageMeta from '../../hooks/usePageMeta';
import { authAPI } from '../../services/api';

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  usePageMeta({
    title: 'Reset Password - Stratel',
    description: 'Request a password reset link for your Stratel client portal account.',
  });

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    setMessage('');
    setError('');

    try {
      const res = await authAPI.forgotPassword(email, 'client');
      setMessage(res?.data?.message || 'If an account exists, a reset email has been sent.');
    } catch (err) {
      setError(err?.response?.data?.message || err?.message || 'Failed to request password reset.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="relative min-h-screen bg-secondary-50 flex items-center justify-center p-6">
      <Link
        to="/login"
        className="absolute left-6 top-6 inline-flex items-center gap-2 text-sm font-medium text-secondary-600 hover:text-secondary-900"
      >
        <ArrowLeft size={18} />
        Back to login
      </Link>

      <div className="w-full max-w-md rounded-2xl bg-white p-8 shadow-xl">
        <div className="mb-6 text-center">
          <h1 className="text-2xl font-display font-bold text-secondary-900">Reset your password</h1>
          <p className="mt-2 text-sm text-secondary-600">Enter your email and we will send a secure reset link.</p>
        </div>

        {error ? (
          <div className="mb-4 flex items-center gap-2 rounded-lg border border-red-200 bg-red-50 p-3 text-sm text-red-700">
            <AlertCircle size={18} />
            {error}
          </div>
        ) : null}

        {message ? (
          <div className="mb-4 rounded-lg border border-green-200 bg-green-50 p-3 text-sm text-green-700">
            {message}
          </div>
        ) : null}

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label htmlFor="email" className="label">Email Address</label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              className="input"
              required
              autoComplete="email"
              placeholder="you@company.com"
            />
          </div>

          <button type="submit" disabled={loading} className="btn-primary w-full">
            {loading ? 'Sending...' : 'Send reset link'}
          </button>
        </form>
      </div>
    </div>
  );
}
